module.exports = __webpack_public_path__ + "media/images/arrow-left-79597521adadb00ca5bcf71323551123.svg";